import { last } from 'lodash';
import { PastProjectStatus } from 'api/project';
import { numberSorter } from 'utils/sorters';
import { KeyCreatorFunction } from './types';

export const pastProjectStatusKeyCreator: KeyCreatorFunction<
  PastProjectStatus[] | undefined
> = ({ value = [] }) => {
  const sortedValue = Array.from(value).sort(
    ({ updatedAt: updatedAtA }, { updatedAt: updatedB }) =>
      numberSorter(updatedAtA, updatedB),
  );
  const lastUpdate = last(sortedValue);

  return lastUpdate?.projectStatusName ?? '';
};
